import { render, staticRenderFns } from "./I18nItemTranslationModal.vue?vue&type=template&id=69e9879a&scoped=true&"
import script from "./I18nItemTranslationModal.vue?vue&type=script&lang=js&"
export * from "./I18nItemTranslationModal.vue?vue&type=script&lang=js&"
import style0 from "./I18nItemTranslationModal.vue?vue&type=style&index=0&id=69e9879a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e9879a",
  null
  
)

export default component.exports